import React from "react";

const AccountDetails = () => {
  return (
    <div className="w-full">
      <div className="flex justify-between w-full gap-5 h-fit items-start">
        {/** account details not found  */}

        {/* <div className="text-center w-4/5">
                 !
              </div> */}

        <form className="address_form">
          <div className="flex justify-between items-center gap-5">
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="firstName">First name*</label>
              <input
                type="text"
                id="firstName"
                placeholder="Enter your first name"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="lastName">Last name*</label>
              <input
                type="text"
                id="lastName"
                placeholder="Enter your last name"
                className="input_field"
              />
            </div>
          </div>
          <div className="flex flex-col gap-1 input_group">
            <label htmlFor="email">Email*</label>
            <input
              type="text"
              id="email"
              placeholder="Enter email"
              className="input_field"
            />
          </div>
          <div className="flex flex-col gap-4">
            <div className=" font-medium text-[18px]">Password</div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="password">Password*</label>
              <input
                type="text"
                id="password"
                placeholder="Password"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="confirmPassword">Confirm password*</label>
              <input
                type="text"
                id="confirmPassword"
                placeholder="Confirm password"
                className="input_field"
              />
            </div>
          </div>
          <div className="flex justify-between items-center gap-5 w-full">
            <div className="add_btn button bg-black py-[10px] px-5 text-white rounded text-[14px]  cursor-pointer w-full text-center">
              <button>Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountDetails;
